import { VipCustomerFormType } from 'components/vip-customers/VipCustomerForm';

export const createVipCustomerInitialValues: Partial<VipCustomerFormType> = {};
